import { configureStore } from '@reduxjs/toolkit'
import citySlice from './../features/city'
import cityWeatherSlice from './../features/cityWeather'
import weatherSlice from './../features/weather'
import favuriteCitySlice from '../features/favuriteCity'
import chronologySlice from '../features/chronology'
import userKeySlice from '../features/userKey'
import darkmodeSlice from '../features/darkmode'

const persistedState = localStorage.getItem('reduxState') 
  ? JSON.parse(localStorage.getItem('reduxState'))
  : {}


let store = configureStore({
  reducer: {
    city: citySlice,
    cityWeather: cityWeatherSlice,
    weather: weatherSlice,
    favuriteCity: favuriteCitySlice,
    chronology: chronologySlice,
    userKey: userKeySlice,
    darkmode: darkmodeSlice
  },
  preloadedState: persistedState
})

store.subscribe(() => {
  let toSave = store.getState()
  let save = { ...toSave, weather: {weather:[]} }
  localStorage.setItem('reduxState', JSON.stringify(save))
})

export default store